import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  ensureRiderPushSubscription,
  registerRiderServiceWorker,
} from "@/lib/pwa/register-rider-sw";
import { RiderAvailabilityToggle } from "./rider-availability-toggle";

export default function RiderShell() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    registerRiderServiceWorker().catch(() => {});
  }, []);

  const onEnablePush = async () => {
    await ensureRiderPushSubscription().catch(() => {});
  };

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="flex items-center justify-between gap-2 border-b px-4 py-3">
        <Link to="/rider" className="text-lg font-semibold">
          {t("rider.shell.title", "Repartidor")}
        </Link>
        <div className="flex items-center gap-2">
          <RiderAvailabilityToggle />
          <Button type="button" variant="outline" size="sm" onClick={onEnablePush}>
            {t("rider.shell.enablePush", "Activar notificaciones")}
          </Button>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto pb-16">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 left-0 right-0 grid grid-cols-2 border-t bg-background">
        <Link
          to="/rider"
          className={`py-3 text-center text-sm ${
            location.pathname === "/rider" ? "font-semibold text-primary" : ""
          }`}
        >
          {t("rider.shell.queue", "Pedidos")}
        </Link>
        <Link
          to="/rider/history"
          className={`py-3 text-center text-sm ${
            location.pathname.startsWith("/rider/history") ? "font-semibold text-primary" : ""
          }`}
        >
          {t("rider.shell.history", "Historial")}
        </Link>
      </nav>
    </div>
  );
}
